"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactForm = exports.ValidationErrorsContactForm = void 0;
const react_1 = __importStar(require("react"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const react_select_1 = __importDefault(require("react-select"));
const countryUtils = __importStar(require("../../utils/countryUtils"));
const validationUtils = __importStar(require("../../utils/validationUtils"));
const ValidationErrors_1 = require("../ValidationErrors");
class ValidationErrorsContactForm extends ValidationErrors_1.ValidationErrors {
    constructor() {
        super(...arguments);
        this.nameInvalid = "";
        this.emailInvalid = "";
        this.phoneInvalid = "";
        this.addressInvalid = "";
        this.zipInvalid = "";
        this.cityInvalid = "";
        this.countryInvalid = "";
    }
}
exports.ValidationErrorsContactForm = ValidationErrorsContactForm;
const ContactForm = (props) => {
    var _a;
    const [validationErrors, setValidationErrors] = (0, react_1.useState)(new ValidationErrorsContactForm());
    // Validate if contact changes.
    (0, react_1.useEffect)(() => {
        const newValidationErrors = validate(props.contact);
        setValidationErrors(newValidationErrors);
        props.isValidChange(!newValidationErrors.hasErrors());
    }, [props.contact]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Row_1.default, null,
            react_1.default.createElement(Col_1.default, { sm: 12 },
                react_1.default.createElement(Form_1.default.Group, { controlId: "org" },
                    react_1.default.createElement(Form_1.default.Label, null, "Organisation (optional)"),
                    react_1.default.createElement(Form_1.default.Control, { type: "text", value: props.contact.org, placeholder: "---", onChange: (e) => props.onContactChange({
                            org: e.target.value.slice(0, 80),
                        }), 
                        // Is always valid. Mark as valid when error messages are turned on.
                        isValid: props.showErrors }))),
            react_1.default.createElement(Col_1.default, { sm: 12 },
                react_1.default.createElement(Form_1.default.Group, { controlId: "name" },
                    react_1.default.createElement(Form_1.default.Label, null, "Vorname und Nachname"),
                    react_1.default.createElement(Form_1.default.Control, { type: "text", value: props.contact.name, onChange: (e) => props.onContactChange({
                            name: e.target.value.slice(0, 60),
                        }), isValid: props.showErrors && validationErrors.nameInvalid === "", isInvalid: props.showErrors && validationErrors.nameInvalid !== "" }),
                    react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.nameInvalid))),
            react_1.default.createElement(Col_1.default, { sm: 12 },
                react_1.default.createElement(Form_1.default.Group, { controlId: "address" },
                    react_1.default.createElement(Form_1.default.Label, null, "Adresse"),
                    react_1.default.createElement(Form_1.default.Control, { as: "textarea", rows: 3, value: `${props.contact.address}`, placeholder: "Strasse und Hausnummer\r\nPostfach, Referenz, Abteilung, c/o, usw.", onChange: (e) => {
                            props.onContactChange({
                                address: e.target.value,
                            });
                        }, isValid: props.showErrors && validationErrors.addressInvalid === "", isInvalid: props.showErrors && validationErrors.addressInvalid !== "" }),
                    react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.addressInvalid))),
            react_1.default.createElement(Col_1.default, { sm: 4 },
                react_1.default.createElement(Form_1.default.Group, { controlId: "zip" },
                    react_1.default.createElement(Form_1.default.Label, null, "Postleitzahl"),
                    react_1.default.createElement(Form_1.default.Control, { type: "text", value: props.contact.zip, onChange: (e) => props.onContactChange({
                            zip: e.target.value.slice(0, 8).trim(),
                        }), isValid: props.showErrors && validationErrors.zipInvalid === "", isInvalid: props.showErrors && validationErrors.zipInvalid !== "" }),
                    react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.zipInvalid))),
            react_1.default.createElement(Col_1.default, { sm: 8 },
                react_1.default.createElement(Form_1.default.Group, { controlId: "city" },
                    react_1.default.createElement(Form_1.default.Label, null, "Ort"),
                    react_1.default.createElement(Form_1.default.Control, { type: "text", value: props.contact.city, onChange: (e) => props.onContactChange({
                            city: e.target.value.slice(0, 30),
                        }), isValid: props.showErrors && validationErrors.cityInvalid === "", isInvalid: props.showErrors && validationErrors.cityInvalid !== "" }),
                    react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.cityInvalid))),
            react_1.default.createElement(Col_1.default, { sm: 12 },
                react_1.default.createElement(Form_1.default.Group, { controlId: "country" },
                    react_1.default.createElement(Form_1.default.Label, null, "Land/Region"),
                    react_1.default.createElement(react_select_1.default, { options: countryUtils.COUNTRIES.map((c) => ({
                            value: c.code,
                            label: c.de,
                        })).sort((a, b) => a.label.localeCompare(b.label)), value: {
                            value: props.contact.country,
                            label: (_a = countryUtils.getCountryName(props.contact.country, "de")) !== null && _a !== void 0 ? _a : props.contact.country,
                        }, onChange: (option) => props.onContactChange({
                            country: option === null || option === void 0 ? void 0 : option.value,
                        }) }))),
            react_1.default.createElement(Col_1.default, { lg: 4 },
                react_1.default.createElement(Form_1.default.Group, { controlId: "phone" },
                    react_1.default.createElement(Form_1.default.Label, null, "Telefon"),
                    react_1.default.createElement(Form_1.default.Control, { type: "tel", value: props.contact.phone, onChange: (e) => props.onContactChange({
                            phone: e.target.value.slice(0, 30),
                        }), isValid: props.showErrors && validationErrors.phoneInvalid === "", isInvalid: props.showErrors && validationErrors.phoneInvalid !== "" }),
                    react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.phoneInvalid))),
            react_1.default.createElement(Col_1.default, { lg: 8 },
                react_1.default.createElement(Form_1.default.Group, { controlId: "email" },
                    react_1.default.createElement(Form_1.default.Label, null, "E-Mail"),
                    react_1.default.createElement(Form_1.default.Control, { type: "email", value: props.contact.email, onChange: (e) => props.onContactChange({
                            email: e.target.value.slice(0, 60),
                        }), isValid: props.showErrors && validationErrors.emailInvalid === "", isInvalid: props.showErrors && validationErrors.emailInvalid !== "" }),
                    react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.emailInvalid))))));
};
exports.ContactForm = ContactForm;
function validate(contact) {
    const errors = new ValidationErrorsContactForm();
    if (contact.name.trim() === "") {
        errors.nameInvalid = "Bitte Namen angeben.";
    }
    if (!validationUtils.validEmail(contact.email)) {
        errors.emailInvalid = "Bitte gültige E-Mail Adresse angeben.";
    }
    if (contact.phone.trim() === "") {
        errors.phoneInvalid = "Bitte Telefon angeben.";
    }
    const maxAddressLines = 5;
    const maxAddressChars = 250;
    if (contact.address.trim() === "") {
        errors.addressInvalid = "Bitte Adresse angeben.";
    }
    else if (contact.address.split("\n").length > maxAddressLines) {
        errors.addressInvalid = `Maximal ${maxAddressLines} Zeilen erlaubt: ${maxAddressLines - contact.address.split("\n").length}`;
    }
    else if (contact.address.length > maxAddressChars) {
        errors.addressInvalid = `Maximal ${maxAddressChars} Zeichen erlaubt: ${maxAddressChars - contact.address.length}`;
    }
    if (contact.zip.trim() === "") {
        errors.zipInvalid = "Bitte PLZ angeben.";
    }
    else if (!contact.zip.trim().match(/^\d+$/)) {
        // Zip contains non-numeric value.
        errors.zipInvalid = "Bitte gültige PLZ angeben (nur Zahlen).";
    }
    if (contact.city.trim() === "") {
        errors.cityInvalid = "Bitte Ort angeben.";
    }
    return errors;
}
